import React from 'react';
import { Zap, TrendingUp, Sliders, Target } from 'lucide-react';

export const WhyChoose = () => {
  const reasons = [
    {
      icon: Zap,
      title: 'Respon Pesanan Lebih Cepat',
      description:
        'BAiBOT merespon pesanan dalam milidetik, lebih cepat dari respon manual',
    },
    {
      icon: TrendingUp,
      title: 'Potensi Penghasilan Lebih Tinggi',
      description:
        'Dengan otomasi cerdas, terima lebih banyak pesanan menguntungkan',
    },
    {
      icon: Sliders,
      title: 'Kustomisasi Penuh',
      description:
        'Atur semua filter dan preferensi sesuai kebutuhan Anda',
    },
    {
      icon: Target,
      title: 'Khusus untuk Driver inDriver',
      description:
        'Dirancang spesifik untuk mengoptimalkan pengalaman driver inDriver',
    },
  ];

  return (
    <section
      style={{
        background: 'var(--bg-primary)',
        padding: '100px 7.6923%',
      }}
    >
      <div
        style={{
          maxWidth: '1400px',
          margin: '0 auto',
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: '60px' }}>
          <h2
            style={{
              fontSize: '48px',
              fontWeight: 600,
              lineHeight: 1.1,
              letterSpacing: '-0.02em',
              color: 'var(--text-primary)',
              marginBottom: '16px',
            }}
          >
            Mengapa Pilih BAiBOT?
          </h2>
          <p
            style={{
              fontSize: '20px',
              fontWeight: 500,
              lineHeight: 1.5,
              color: 'var(--text-secondary)',
            }}
          >
            Keunggulan yang membuat BAiBOT berbeda
          </p>
        </div>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '40px',
          }}
          className="why-grid"
        >
          {reasons.map((reason, index) => {
            const Icon = reason.icon;
            return (
              <div
                key={index}
                style={{
                  background: 'var(--bg-secondary)',
                  border: '1px solid var(--border-subtle)',
                  padding: '40px',
                  textAlign: 'center',
                  transition: 'all 0.4s ease-in-out',
                }}
                className="dark-hover"
              >
                <div
                  style={{
                    width: '80px',
                    height: '80px',
                    background: 'var(--brand-primary)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 24px',
                  }}
                >
                  <Icon size={36} color="#000000" />
                </div>
                <h3
                  style={{
                    fontSize: '24px',
                    fontWeight: 600,
                    lineHeight: 1.3,
                    color: 'var(--text-primary)',
                    marginBottom: '12px',
                  }}
                >
                  {reason.title}
                </h3>
                <p
                  style={{
                    fontSize: '16px',
                    fontWeight: 400,
                    lineHeight: 1.4,
                    color: 'var(--text-secondary)',
                  }}
                >
                  {reason.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
      <style>
        {`
          @media (max-width: 767px) {
            .why-grid {
              grid-template-columns: 1fr !important;
            }
          }
        `}
      </style>
    </section>
  );
};